const RenderIf = ({ isTrue, children }) => (isTrue ? children : null);

export default RenderIf;
